module.exports = __webpack_public_path__ + "img/icon-search-lightblue.dc6082f7.svg";